import React, { useEffect, useState } from "react";
import AzDesign from "./AzDesign";
import { AppStoreButton, GooglePlayButton } from "react-mobile-app-button";
import checkmate from "./cod/imgs/checkmate.png";
import popl2 from "./cod/imgs/popl2.png";

const githubURL = "https://github.com/dzach2";
const githubIcon = (fill) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
      <path fill={fill} d="M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM265.8 407.7c0-1.8 0-6 .1-11.6c.1-11.4 .1-28.8 .1-43.7c0-15.6-5.2-25.5-11.3-30.7c37-4.1 76-9.2 76-73.1c0-18.2-6.5-27.3-17.1-39c1.7-4.3 7.4-22-1.7-45c-13.9-4.3-45.7 17.9-45.7 17.9c-13.2-3.7-27.5-5.6-41.6-5.6s-28.4 1.9-41.6 5.6c0 0-31.8-22.2-45.7-17.9c-9.1 22.9-3.5 40.6-1.7 45c-10.6 11.7-15.6 20.8-15.6 39c0 63.6 37.3 69 74.3 73.1c-4.8 4.3-9.1 11.7-10.6 22.3c-9.5 4.3-33.8 11.7-48.3-13.9c-9.1-15.8-25.5-17.1-25.5-17.1c-16.2-.2-1.1 10.2-1.1 10.2c10.8 5 18.4 24.2 18.4 24.2c9.7 29.7 56.1 19.7 56.1 19.7c0 9 .1 21.7 .1 30.6c0 4.8 .1 8.6 .1 10c0 4.3-3 9.5-11.5 8C106 393.6 59.8 330.8 59.8 257.4c0-91.8 70.2-161.5 162-161.5s166.2 69.7 166.2 161.5c.1 73.4-44.7 136.3-110.7 158.3c-8.4 1.5-11.5-3.7-11.5-8zm-90.5-54.8c-.2-1.5 1.1-2.8 3-3.2c1.9-.2 3.7 .6 3.9 1.9c.3 1.3-1 2.6-3 3c-1.9 .4-3.7-.4-3.9-1.7zm-9.1 3.2c-2.2 .2-3.7-.9-3.7-2.4c0-1.3 1.5-2.4 3.5-2.4c1.9-.2 3.7 .9 3.7 2.4c0 1.3-1.5 2.4-3.5 2.4zm-14.3-2.2c-1.9-.4-3.2-1.9-2.8-3.2s2.4-1.9 4.1-1.5c2 .6 3.3 2.1 2.8 3.4c-.4 1.3-2.4 1.9-4.1 1.3zm-12.5-7.3c-1.5-1.3-1.9-3.2-.9-4.1c.9-1.1 2.8-.9 4.3 .6c1.3 1.3 1.8 3.3 .9 4.1c-.9 1.1-2.8 .9-4.3-.6zm-8.5-10c-1.1-1.5-1.1-3.2 0-3.9c1.1-.9 2.8-.2 3.7 1.3c1.1 1.5 1.1 3.3 0 4.1c-.9 .6-2.6 0-3.7-1.5zm-6.3-8.8c-1.1-1.3-1.3-2.8-.4-3.5c.9-.9 2.4-.4 3.5 .6c1.1 1.3 1.3 2.8 .4 3.5c-.9 .9-2.4 .4-3.5-.6zm-6-6.4c-1.3-.6-1.9-1.7-1.5-2.6c.4-.6 1.5-.9 2.8-.4c1.3 .7 1.9 1.8 1.5 2.6c-.4 .9-1.7 1.1-2.8 .4z" />
    </svg>
  )
}

const linkedinURL = "https://www.linkedin.com/in/dannyzachary/";
const linkedinIcon = (fill) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
      <path fill={fill} d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z" />
    </svg>
  )
}

const instagramURL = "https://www.instagram.com/dannyzachary/";
const instagramIcon = (fill) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
      <path fill={fill} d="M194.4 211.7a53.3 53.3 0 1 0 59.3 88.7 53.3 53.3 0 1 0 -59.3-88.7zm142.3-68.4c-5.2-5.2-11.5-9.3-18.4-12c-18.1-7.1-57.6-6.8-83.1-6.5c-4.1 0-7.9 .1-11.2 .1c-3.3 0-7.2 0-11.4-.1c-25.5-.3-64.8-.7-82.9 6.5c-6.9 2.7-13.1 6.8-18.4 12s-9.3 11.5-12 18.4c-7.1 18.1-6.7 57.7-6.5 83.2c0 4.1 .1 7.9 .1 11.1s0 7-.1 11.1c-.2 25.5-.6 65.1 6.5 83.2c2.7 6.9 6.8 13.1 12 18.4s11.5 9.3 18.4 12c18.1 7.1 57.6 6.8 83.1 6.5c4.1 0 7.9-.1 11.2-.1c3.3 0 7.2 0 11.4 .1c25.5 .3 64.8 .7 82.9-6.5c6.9-2.7 13.1-6.8 18.4-12s9.3-11.5 12-18.4c7.2-18 6.8-57.4 6.5-83c0-4.2-.1-8.1-.1-11.4s0-7.1 .1-11.4c.3-25.5 .7-64.9-6.5-83l0 0c-2.7-6.9-6.8-13.1-12-18.4zm-67.1 44.5A82 82 0 1 1 178.4 324.2a82 82 0 1 1 91.1-136.4zm29.2-1.3c-3.1-2.1-5.6-5.1-7.1-8.6s-1.8-7.3-1.1-11.1s2.6-7.1 5.2-9.8s6.1-4.5 9.8-5.2s7.6-.4 11.1 1.1s6.5 3.9 8.6 7s3.2 6.8 3.2 10.6c0 2.5-.5 5-1.4 7.3s-2.4 4.4-4.1 6.2s-3.9 3.2-6.2 4.2s-4.8 1.5-7.3 1.5l0 0c-3.8 0-7.5-1.1-10.6-3.2zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM357 389c-18.7 18.7-41.4 24.6-67 25.9c-26.4 1.5-105.6 1.5-132 0c-25.6-1.3-48.3-7.2-67-25.9s-24.6-41.4-25.8-67c-1.5-26.4-1.5-105.6 0-132c1.3-25.6 7.1-48.3 25.8-67s41.5-24.6 67-25.8c26.4-1.5 105.6-1.5 132 0c25.6 1.3 48.3 7.1 67 25.8s24.6 41.4 25.8 67c1.5 26.3 1.5 105.4 0 131.9c-1.3 25.6-7.1 48.3-25.8 67z" />
    </svg>
  )
}

const poplURL = "https://popl.co";
const poplIcon = (fill) => {
  return (
    <svg width="391" height="391" viewBox="0 0 391 391" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="16" y="16" width="359" height="359" rx="63" fill={fill} />
      <path d="M194.419 318C132.719 318 78.0652 265.911 74 203.803H96.8101C110.903 203.803 123.414 212.013 128.609 224.722C140.081 252.599 166.686 271.338 194.826 271.338C224.727 271.338 251.512 253.434 263.12 225.789C268.721 212.43 281.097 203.803 294.648 203.803H318C313.935 260.298 267.05 318 194.419 318ZM294.422 187.151C281.052 187.151 268.857 178.616 263.346 165.443C251.738 137.613 225.179 119.662 195.593 119.662C166.008 119.662 140.443 138.169 128.835 165.675C123.279 178.709 111.128 187.151 97.849 187.151H74.0903C78.562 120.868 130.19 73 197.581 73C229.967 73 261.63 86.5905 284.44 110.246C304.133 130.702 315.967 157.975 317.91 187.197H294.377L294.422 187.151Z" fill="white" />
    </svg>
  )
}

const checkmateURL = "https://apps.apple.com/us/app/checkmate-routine-tracker/id6740780637";
const checkmateIcon = (fill) => {
  return (
    <svg width="391" height="391" viewBox="0 0 391 391" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="16" y="16" width="359" height="359" rx="63" fill={fill} />
      <path d="M152.853 269H125.409C123.006 268.999 120.655 268.3 118.641 266.987C116.627 265.674 115.037 263.804 114.063 261.603C113.09 259.403 112.776 256.966 113.158 254.59C113.541 252.214 114.604 250 116.218 248.217L240.453 111H298L156.325 267.452C155.887 267.939 155.351 268.328 154.753 268.594C154.155 268.861 153.508 268.999 152.853 269Z" fill="white" />
      <path d="M152.927 268.998H103.187C101.455 268.996 99.7423 268.631 98.1586 267.927C96.5749 267.223 95.1552 266.195 93.9906 264.908L54 220.759L82.7755 189L153.69 267.265C153.839 267.408 153.941 267.594 153.981 267.797C154.021 268 153.998 268.211 153.914 268.4C153.831 268.589 153.691 268.748 153.515 268.855C153.338 268.962 153.133 269.012 152.927 268.998Z" fill="white" />
      <path d="M209.029 230.717C217.696 221.104 232.515 220.338 242.127 229.005C251.74 237.672 252.506 252.491 243.839 262.103C235.172 271.716 220.353 272.482 210.74 263.815C201.128 255.148 200.361 240.329 209.029 230.717Z" fill="white" stroke="white" />
      <path d="M247.888 187.537C256.555 177.924 271.374 177.158 280.987 185.825C290.599 194.492 291.366 209.311 282.698 218.924C274.031 228.536 259.212 229.303 249.6 220.635C239.987 211.968 239.221 197.149 247.888 187.537Z" fill="white" stroke="white" />
      <path d="M286.79 144.39C295.458 134.778 310.276 134.011 319.889 142.679C329.502 151.346 330.268 166.165 321.601 175.777C312.933 185.39 298.115 186.156 288.502 177.489C278.889 168.822 278.123 154.003 286.79 144.39Z" fill="white" stroke="white" />
    </svg>
  )
}

const SOCIAL_LINKS = [
  { key: "github", url: githubURL, label: "GitHub", Icon: githubIcon },
  { key: "linkedin", url: linkedinURL, label: "LinkedIn", Icon: linkedinIcon },
  { key: "instagram", url: instagramURL, label: "Instagram", Icon: instagramIcon },
  { key: "popl", url: poplURL, label: "Popl", Icon: poplIcon },
];

const Bio = (props) => {
  const {
    contentType,
    setContentType,
    toggleSwitch,
  } = props;

  const [initDesign, setInitDesign] = useState(true);

  useEffect(() => {
    setInitDesign(!initDesign);
  }, []);

  const iconColor = toggleSwitch ? "#333" : "#fff";

  return (
    <>
      <div className="bioDiv">
        <div
          className="rightOfPicDiv"
          style={
            toggleSwitch
              ? { color: "#333" }
              : { color: "#fff" }
          }
        >
          <h1>
            Danny Zachary
          </h1>
          {/* <div className="poplTextFlexDiv">
            <p>
              PHX
            </p>
          </div> */}
          <div className="socialButtonsDiv">
            {SOCIAL_LINKS.map(({ key, url, label, Icon }) => (
              <a
                key={key}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="socialButton"
                aria-label={label}
              >
                {Icon(iconColor)}
                <p>{label}</p>
              </a>
            ))}
          </div>
          {/* <div className="downloadBtns">
            <div className="downloadBtnsInner">
              <img height={18} src={popl2} />
              <AppStoreButton
                height={26}
                title="Download Popl"
                className="button-app-store"
                url="https://apps.apple.com/us/app/popl-digital-business-card/id1503939262"
                theme="dark"
                />
              <GooglePlayButton
                height={26}
                title="Download Popl"
                className="button-app-store"
                url="https://play.google.com/store/apps/details?id=com.nfc.popl&hl=en_US&pli=1"
                theme="dark"
                />
            </div>
            <div className="downloadBtnsInner">
              <img height={15} src={checkmate} />
              <AppStoreButton
                height={26}
                title="Try Checkmate"
                className="button-app-store"
                url="https://apps.apple.com/us/app/checkmate-routine-tracker/id6740780637"
                theme="dark"
              />
            </div>
          </div> */}
        </div>
        {/* <AzDesign initDesign={initDesign} /> */}
        {/* 
        <div
          style={contentType === "map" ? { boxShadow: "10px 0px 6px 2px #09524d25 inset" } : { boxShadow: "-10px 0px 6px 2px #09524d15 inset" }}
          className="contentSwitcher"
        >
          <div
            onClick={() => setContentType("map")}
            className="contentOption"
            style={{ paddingLeft: 4 }}
          >

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
              <path class="fa-secondary" style={contentType !== "map" ? { opacity: ".2" } : { opacity: ".5" }} d="M416 503V200.4c3.5-6.9 6.7-13.8 9.6-20.6c.5-1.2 1-2.5 1.5-3.7l116-46.4C558.9 123.4 576 135 576 152V422.8c0 9.8-6 18.6-15.1 22.3L416 503zM15.1 187.3l122.6-49c2.4 14.1 7.2 28.3 12.8 41.5c2.9 6.8 6.1 13.7 9.6 20.6V451.8L32.9 502.7C17.1 509 0 497.4 0 480.4V209.6c0-9.8 6-18.6 15.1-22.3zM384 255V504.3L192 449.4V255c20.5 31.3 42.3 59.6 56.2 77c20.5 25.6 59.1 25.6 79.6 0c13.9-17.4 35.7-45.7 56.2-77z" />
              <path class="fa-primary" style={contentType !== "map" ? { opacity: ".4" } : { fill: "green" }} d="M302.8 312C334.9 271.9 408 174.6 408 120C408 53.7 354.3 0 288 0S168 53.7 168 120c0 54.6 73.1 151.9 105.2 192c7.7 9.6 22 9.6 29.6 0zM288 72a40 40 0 1 1 0 80 40 40 0 1 1 0-80z" />
            </svg>
            
          </div>
          <div
            onClick={() => setContentType("sign")}
            className="contentOption"
            style={{ paddingRight: 4 }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path class="fa-secondary" style={contentType !== "sign" ? { opacity: ".4" } : { opacity: ".6", fill: "red" }} d="M256 0c-17.7 0-32 14.3-32 32V64h64V32c0-17.7-14.3-32-32-32zm32 480V256H224V480c0 17.7 14.3 32 32 32s32-14.3 32-32z" />
              <path class="fa-primary" style={contentType !== "sign" ? { opacity: ".2" } : null} d="M441.6 75.5l61.9 74.2c4.9 5.9 4.9 14.6 0 20.5l-61.9 74.2c-6.1 7.3-15.1 11.5-24.6 11.5H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H417c9.5 0 18.5 4.2 24.6 11.5z" />
            </svg>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default Bio;
